// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"aedf19a5","58":"15db3870","145":"ec012ab3","266":"a2c06f42","326":"93b2f2c8","396":"3bbbdeeb","411":"fb3bb4f2","460":"3e57ec90","490":"fcd3606b","736":"6bf78189","812":"7e0ce89b","990":"0e3c18eb"}[chunkId] + ".chunk.js";
};